// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const SETQRIMAGE = 'SETQRIMAGE';
export const REQUIRESETPASSWORD = 'REQUIRESETPASSWORD';
export const SESSION_TIMEOUT = 'SESSION_TIMEOUT';
export const SETUSER_NAME = 'SETUSER_NAME';

export default {
    LOGIN,
    LOGOUT,
    REGISTER,
    SETQRIMAGE,
    REQUIRESETPASSWORD,
    SESSION_TIMEOUT,
    SETUSER_NAME
};
